import { render, staticRenderFns } from "./avaluoForm.vue?vue&type=template&id=5fcc1f66&scoped=true&"
import script from "./avaluoForm.vue?vue&type=script&lang=js&"
export * from "./avaluoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcc1f66",
  null
  
)

export default component.exports